import {
	mergeObject
} from './helper';

/**
 * Masks and blocks element passed
 *
 * @param {HTML Element} element
 * @param {Object} settings
 */
export function block(element, settings) {

	if (undefined === element) {
		console.warn('block element undefined');
		return;
	}

	// if the element is blocked or blocking, return
	if (element.dataset.hpyBlock === 'blocked' || element.dataset.hpyBlock === 'blocking') {
		return;
	}

	// if no settings are defined then create an empty object
	if (undefined === settings) {
		settings = {};
	}

	// create the mask element
	let mask = document.createElement('div');
	let defaults = {
		color: '#FFFFFF',
		opacity: '0.8',
		cursor: '',
		zIndex: '',
		pointerEvents: '',
		HTML: ''
	};

	settings = mergeObject(settings, defaults);

	mask.style.backgroundColor = settings.color;
	mask.classList.add('hpyBlock');
	mask.innerHTML = settings.HTML;;

	// only set the parent to relative positioning if tis' not absolute
	if (element.style.position != 'absolute') {
		element.style.position = 'relative';
	}

	// append the mask to the element being blocked
	element.appendChild(mask);
	element.dataset.hpyBlock = 'blocking'; // set a data attribute to show it's now blocked

	let computedStyle = window.getComputedStyle(mask); // get the initial style applied by the stylesheet
	let transitionDurationInMilliseconds = parseFloat(computedStyle.transitionDuration) * 1000;

	if (isNaN(transitionDurationInMilliseconds)) {
		return;
	}

	mask.dataset.blockTransition = transitionDurationInMilliseconds; // set the transition timing for the callback
	mask.style.opacity = settings.opacity; // animate in the mask using css transition
	mask.style.cursor = settings.cursor // set custom cursor
	mask.style.zIndex = settings.zIndex // set custom z-index

	element.style.pointerEvents = settings.pointerEvents; // Change pointer event for element

	// set a callback to update the element data to fire after the css animation is complete
	setTimeout(
		() => {
			element.dataset.hpyBlock = 'blocked';
		},
		transitionDurationInMilliseconds
	);
}

/**
 * Unblocks a previously blocked element
 *
 * @param {HTML Element} element
 */
export function unblock(element) {
	if (element.dataset.hpyBlock !== 'blocked') {
		console.warn('Element not blocked');
		return;
	}

	let children = element.children;
	let mask;

	for (let i = 0; i < children.length; i += 1) {
		if (children[i].className === 'hpyBlock') {
			mask = children[i];
			break;
		}
	}
	mask.style.opacity = 0;
	element.dataset.hpyBlock = 'blocking';

	setTimeout(
		() => {
			element.dataset.hpyBlock = '';
			element.removeChild(mask);
			element.style.pointerEvents = '';
		},
		mask.dataset.blockTransition
	);
}

/**
 * Toggles between blocked and unblocked depending on elements data state
 *
 * @param {HTML Element} element
 */
export function toggleBlock(element, settings = '') {
	if (element.dataset.hpyBlock === 'blocked') {
		unblock(element);
	} else {
		block(element, settings);
	}
}
